import React from 'react';

const EditingContext = React.createContext({});

export default EditingContext;
